<template>
    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="hasExtendedFilter"
                @on-filter-click="onFilterClick"
            />
        </Toolbar>

        <component
            :is="collection"
            :search="search"
            ref="currentComponent"
        />

    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';

import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';

import OnAdjustment from './InWorkLists/OnAdjustment.vue';
import OnCheck from './InWorkLists/OnCheck.vue';
import OnExecution from './InWorkLists/OnExecution.vue';
import OnInspect from './InWorkLists/OnInspect.vue';
import OnSign from './InWorkLists/OnSign.vue';
import OnRework from './InWorkLists/OnRework.vue';
import OnControl from './InWorkLists/OnControl.vue';
import OnInspectResolution from './InWorkLists/OnInspectResolution.vue';
import OnRegister from './InWorkLists/OnRegister.vue';
import OnTakeNote from './InWorkLists/OnTakeNote.vue';

export default {
    name: "InWorkProxy",
    components: {
        Toolbar,
        SearchPanel,
        "Documents.My.OnAdjustment": OnAdjustment,
        "Documents.My.OnCheck": OnCheck,
        "Documents.My.OnExecution": OnExecution,
        "Documents.My.OnInspect": OnInspect,
        "Documents.My.OnSign": OnSign,
        "Documents.My.OnRework": OnRework,
        "MyDocuments.OnControl": OnControl,
        "Documents.My.OnInspect.Resolution": OnInspectResolution,
        "Documents.My.OnRegister": OnRegister,
        "Documents.My.OnTakeNote": OnTakeNote,
    },
    computed: {
        collection() {
            return this.$store.getters['correspondence/inWork/getCollection'];
        },
        search: {
            get: function() {
                var searches = this.$store.getters['correspondence/inWork/getSearches'];

                if (!searches) return "";
                
                return searches.find(x => x.collection == this.collection)?.value ?? "";
            },
            set: _.debounce(function(v) {
                if (typeof this.$refs.currentComponent?.resetPage === "function")
                    this.$refs.currentComponent.resetPage();

                this.$store.commit('correspondence/inWork/PUSH_SEARCH', { collection: this.collection, value: v } );
            }, 500)
        },
        hasExtendedFilter() {
            return this.collection == "Documents.My.OnRegister" && this.$store.getters['correspondence/inWork/onRegister/getCategory'] != "CorrespondenceChancelleryResolutions";
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(event, btn) {
            this[btn.Action]();
        },
        async Refresh() {
            this.$refs.currentComponent.getData(true);
        },
        async onFilterClick(){
            this.$refs.currentComponent.onFilterClick();
        }
    },
    async created () {
        this.setOverlayVisible({ visible: true });
        try
        {
            this.$store.commit('documents/toolbar/SET_MENU', { menu: [{ Action: "Refresh", Icon: "refresh", Text: "Обновить", ToolTip: "Обновить_форму" }]});
        }
        finally
        {
            this.setOverlayVisible({ visible: false });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(async vm =>
        {
            const collection = to.params.collection;
            vm.$store.commit('correspondence/inWork/SET_COLLECTION', collection);
        });
    },
    beforeRouteUpdate(to, from, next) {
        const collection = to.params.collection;
        this.$store.commit('correspondence/inWork/SET_COLLECTION', collection);
        next();
    },
}
</script>